import { ICustomFieldDefinition, ITaskProjectCustomField } from '@common/interfaces/customField'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

// The library list. Mutations (create/update/delete) flip isSaving; the page
// refetches the list on their success rather than folding rows in here, so the
// ordered options come straight from the server.
const customFieldsData = createLoadingDataReducer<ICustomFieldDefinition[] | null>(
  [actions.LIST_CUSTOM_FIELDS_REQUEST],
  [
    actions.CREATE_CUSTOM_FIELD_REQUEST,
    actions.UPDATE_CUSTOM_FIELD_REQUEST,
    actions.DELETE_CUSTOM_FIELD_REQUEST,
  ],
)

// The current project's attached fields. Refetched on mutation success, same as
// the library list.
const projectFieldsData = createLoadingDataReducer<ITaskProjectCustomField[] | null>(
  [actions.LIST_PROJECT_CUSTOM_FIELDS_REQUEST],
  [
    actions.ATTACH_PROJECT_CUSTOM_FIELD_REQUEST,
    actions.UPDATE_PROJECT_CUSTOM_FIELD_REQUEST,
    actions.REORDER_PROJECT_CUSTOM_FIELDS_REQUEST,
    actions.DETACH_PROJECT_CUSTOM_FIELD_REQUEST,
  ],
)

export default combineReducers({
  customFieldsData,
  projectFieldsData,
})
